export default function randomInt(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}



// WEBPACK FOOTER //
// ./src/utils/randomInt.js